__turbopack_context__.v({
  "root": "YOBJUW_root",
  "sidebar-container": "YOBJUW_sidebar-container",
  "sidebar-container-inner": "YOBJUW_sidebar-container-inner",
  "sidebar-container-inner-wrapper": "YOBJUW_sidebar-container-inner-wrapper",
  "sidebar-main": "YOBJUW_sidebar-main",
  "sidebar-overlay": "YOBJUW_sidebar-overlay",
});
